// @flow

import { setNcobStripeKeyForCountry } from 'config/stripeKey';

import { SALON_DETAILS_SUCCESS } from 'booking/constants';

/**
 * When salon details are loaded, set the active Stripe key from the salon's country
 * (US => NCOB_STRIPE_KEY_US, else NCOB_STRIPE_KEY). All Stripe usage should use
 * getNcobStripeKey() from config/stripeKey.
 */
export default function stripeSalonKeyMiddleware() {
  return () => next => action => {
    if (action.type === SALON_DETAILS_SUCCESS && action.response) {
      const countryCode = action.response.country && action.response.country.code;
      setNcobStripeKeyForCountry(countryCode);
    }
    return next(action);
  };
}
